// 必应埋点
;(function (w, d, t, r, u) {
  let f
  let n
  let i
  w[u] = w[u] || []
  f = function () {
    const o = { ti: '343131057', enableAutoSpaTracking: true }
    o.q = w[u]
    w[u] = new UET(o)
    w[u].push('pageLoad')
  }
  n = d.createElement(t)
  n.src = r
  n.async = 1
  n.onload = n.onreadystatechange = function () {
    const s = this.readyState
    if (!(s && s !== 'loaded' && s !== 'complete')) {
      f()
      n.onload = null
      n.onreadystatechange = null
    }
  }
  i = d.getElementsByTagName(t)[0]
  i.parentNode.insertBefore(n, i)
})(window, document, 'script', '//bat.bing.com/bat.js', 'uetq')
